import { useRouter } from 'next/router'

// Libs
import type { TabItemType } from '../utils/types'
import { useCategoryList } from './useCategoryList'

const useActiveCategory = () => {
  const router = useRouter()
  const SEARCH_CATEGORIES = useCategoryList()
  const activeTab = (router.query.category || SEARCH_CATEGORIES[0].value) as TabItemType['value']
  return activeTab
}

export default useActiveCategory
